import { useEffect, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { PieChart, Pie, Sector, ResponsiveContainer } from "recharts";
import fetchDataGate from "../../../services/fetchDataGate";

const renderActiveShape = (props: any) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#5766ED"
      >{`Gatepass : ${value}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#5766ED"
      >
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

export default function ReasonChart({ dates }: any) {
  const [data, setData] = useState<any>([]);
  const [active, setActive] = useState<number>(0);

  const onPieEnter = (_: any, index: number) => {
    setActive(index);
  };

  const handleFetchData = async () => {
    let rawdata: any = [];
    const response = await fetchDataGate({
      uri: `api/gatepass/reports/reasons?start=${dates?.startDate}&end=${dates?.endDate}`,
    });

    if (response?.success) {
      response?.payload.forEach((item: any) => {
        rawdata.push({
          name: item?._id,
          value: item?.gatepasses?.length,
          data: item?.gatepasses,
        });
      });
      setData(rawdata);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [dates]);

  if (data.length === 0) {
    return (
      <div className="">
        <div className="flex flex-col justify-center items-center pt-28">
          <div className="">
            <BsSearch color="gray" />
          </div>
          <div className="text-gray-400">No Data Found</div>
        </div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart width={400} height={400}>
        <Pie
          activeIndex={active}
          activeShape={renderActiveShape}
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={100}
          outerRadius={120}
          fill="#5766ED"
          dataKey="value"
          onMouseEnter={onPieEnter}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
